import React from 'react';
import { ReactComponent as ShareResultsIllustration } from '../assets/espaces-culturel/undraw_share-results_lfh5.svg';

const HomeSectionSeam = () => (
  <div className="home-section-seam" aria-hidden="true">
    <div className="home-section-seam__inner">
      <figure className="home-section-seam__figure">
        <ShareResultsIllustration className="home-section-seam__svg" focusable="false" />
      </figure>
    </div>
  </div>
);

export default HomeSectionSeam;
